import { Modal } from 'antd'
import { useDeleteWorkareaMutation } from '../../../../../domain/workareas/workareaQueries'
import { useContext } from 'react'
import JobPlanContext from '../../JobPlanContext'

type Props = {
  isOpen: boolean
  onCancel: () => void
  workareaId: number | undefined
  workareaName: string | undefined
  isWorkareaGroupApproved: boolean
  hasChildRecurringWorkareas: boolean
  jobId: number
}

const DeleteWorkareaModal = ({ isOpen, onCancel, jobId, workareaId, workareaName, isWorkareaGroupApproved, hasChildRecurringWorkareas }: Props) => {
  const { currentSelection, clearSelection} = useContext(JobPlanContext)
  const deleteWorkareaMutation = useDeleteWorkareaMutation(() => {
    onCancel()
    if(currentSelection?.workareaId === workareaId) {
      clearSelection()
    } 
  })

  const handleDelete = () => {
    if (workareaId) {
      deleteWorkareaMutation.mutate({ workareaId, jobId })
    }
  }

  return <Modal
    title={
      hasChildRecurringWorkareas || isWorkareaGroupApproved
      ? <p>{workareaName} cannot be deleted</p>
      : <p>Are you sure you want to delete <strong>{workareaName}</strong>?</p>
    }
    open={isOpen}
    onOk={handleDelete}
    onCancel={onCancel}
    okText="Delete"
    cancelText="Cancel"
    okButtonProps={{ 
      danger: true, 
      loading: deleteWorkareaMutation.isLoading, 
      disabled: deleteWorkareaMutation.isLoading || hasChildRecurringWorkareas || isWorkareaGroupApproved 
    }}
    cancelButtonProps={{ disabled: deleteWorkareaMutation.isLoading }}
  >
    {
      isWorkareaGroupApproved
      ? <p>It cannot be deleted because its group is approved.</p>
      : hasChildRecurringWorkareas
        ? <p>This is the master recurring workarea. It cannot be deleted until the other recurring workareas have been deleted first.</p>
        : <p>This action cannot be undone.</p>
    }
  </Modal>
}

export default DeleteWorkareaModal